// src/services/contactChangeSummary.ts
// -------------------------------------
// PURE: which portal-owned Unleashed Customer CONTACT fields changed between the
// prior contact (a user_shelters membership row) and the edited values. Used to stamp
// a contact push job's payload.changes so the Push List inspect modal shows "Name
// changed from X to Y", "Email changed …", etc. — the contact-side twin of
// shelterChangeSummary. Only the fields the arm PUSHES (contactMap: FirstName /
// LastName / EmailAddress / MobilePhone / PhoneNumber) are compared; the Primary
// (IsDefault) change is stamped separately at the primary-change point (it isn't part
// of the edit form). Returns [] when nothing pushed-relevant changed. No React / no DB.

export interface ContactChange {
  label: string;
  from: string;
  to: string;
}

interface ContactLike {
  first_name?: unknown;
  last_name?: unknown;
  email?: unknown;
  phone?: unknown;
  mobile?: unknown;
}

const str = (v: unknown): string => String(v ?? "").trim();
const dash = (s: string): string => (s === "" ? "—" : s);

export function computeContactChanges(
  oldC: ContactLike | null | undefined,
  newC: ContactLike | null | undefined
): ContactChange[] {
  const o = oldC || {};
  const n = newC || {};
  const out: ContactChange[] = [];

  const scalar = (label: string, key: keyof ContactLike) => {
    const from = str(o[key]);
    const to = str(n[key]);
    if (from !== to) out.push({ label, from: dash(from), to: dash(to) });
  };
  scalar("First name", "first_name");
  scalar("Last name", "last_name");
  scalar("Email", "email");
  scalar("Mobile", "mobile");
  scalar("Phone", "phone");

  return out;
}
